import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from './screens/Home';
import './App.css';
import AppShellContainer from "./components/AppShellContainer";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from "react";
import { ErrorModal } from './components/InfoModal';
import { REDUX_LOAD_STATUS } from "./enums/CommonEnums";
import Registration from "./screens/Registration";
import { getAuthState } from "./redux/slices/authSlice";
import UserLogin from "./screens/UserLogin";
import NotFound from "./screens/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import ContainerRegistrations from "./screens/ContainerRegistrations";
import UserProfileScreen from "./screens/UserProfileScreen";
import FAQ from "./screens/FAQ";
import ResetPassword from "./screens/ResetPassword";
import AccountRegisterGuide from "./screens/AccountRegisterGuide";
import AdminViewUsers from "./screens/AdminViewUsers";
import AdminViewUserProfile from "./screens/AdminViewUserProfile";
import ContainerSubmissionsGuide from "./screens/ContainerSubmissionsGuide";

function App() {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);

  // FETCH API resource here and update redux store
  useEffect(() => {
    dispatch(getAuthState());
  }, [])

  return (
    <Router>
      <AppShellContainer>
        {
          (authState.loadState === REDUX_LOAD_STATUS.ERROR) &&
            <ErrorModal 
              title="Error"
              description="Error communicating with the server."
              handleCloseModal={() => {}}
            />
        }
        <Routes>
          <Route index element={<Home />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/authenticate" element={<UserLogin />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/accountregisterguide" element={<AccountRegisterGuide />} />
          <Route path="/containersubmissionguide" element={<ContainerSubmissionsGuide />} />

          <Route path="/submissions" element={
            <ProtectedRoute 
              isAuthenticated={authState.isAuthenticated}
              user={authState.user}
            >
              <ContainerRegistrations />
            </ProtectedRoute>
          } />

          <Route path="/admin/users" element={
            <ProtectedRoute 
              isAuthenticated={authState.isAuthenticated}
              adminRequired={true}
              user={authState.user}
            >
              <AdminViewUsers />
            </ProtectedRoute>
          } />

          <Route path="/admin/users/:id" element={
            <ProtectedRoute 
              isAuthenticated={authState.isAuthenticated}
              adminRequired={true}
              user={authState.user}
            >
              <AdminViewUserProfile />
            </ProtectedRoute>
          } />

          <Route path="/profile" element={
            <ProtectedRoute 
              isAuthenticated={authState.isAuthenticated}
              user={authState.user}
            >
              <UserProfileScreen />
            </ProtectedRoute>
          } />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppShellContainer>
    </Router>
  );
}

export default App;
